import { formatPrice } from '../lib/partDisplay'
import {
  isConsolidatedPart,
  optionDefinitions,
  partVariants,
  selectedVariantId,
} from '../lib/partVariants'
import type { WatchPart } from '../api/client'

type CatalogCaseVariantsPanelProps = {
  part: WatchPart
}

export function CatalogCaseVariantsPanel({ part }: CatalogCaseVariantsPanelProps) {
  if (!isConsolidatedPart(part)) {
    return null
  }

  const variants = partVariants(part)
  const options = optionDefinitions(part)
  const currentVariantId = selectedVariantId(part)
  const priceMin = part.metadata?.price_min
  const priceMax = part.metadata?.price_max

  return (
    <section className="catalog-editor-section catalog-case-variants">
      <h2>Case variants</h2>
      <p className="catalog-case-variants-summary">
        {variants.length} Shopify variants consolidated into this catalog entry.
        {typeof priceMin === 'number' && typeof priceMax === 'number' && priceMin !== priceMax
          ? ` Price range ${formatPrice(priceMin, part.currency)} – ${formatPrice(priceMax, part.currency)}.`
          : null}
      </p>

      {options.length > 0 ? (
        <div className="catalog-case-options">
          {options.map((option) => (
            <div key={`${option.position}-${option.name}`} className="catalog-case-option">
              <strong>{option.name}</strong>
              <span>{option.values.join(' · ')}</span>
            </div>
          ))}
        </div>
      ) : null}

      <div className="catalog-case-variant-table-wrap">
        <table className="catalog-case-variant-table">
          <thead>
            <tr>
              <th>Variant</th>
              <th>Options</th>
              <th>Price</th>
              <th>Available</th>
              <th>Default</th>
            </tr>
          </thead>
          <tbody>
            {variants.map((variant) => (
              <tr key={variant.variant_id} className={variant.variant_id === currentVariantId ? 'is-default' : ''}>
                <td>
                  <div className="catalog-case-variant-title">{variant.title}</div>
                  <div className="catalog-case-variant-id">{variant.variant_id}</div>
                </td>
                <td>
                  {variant.option_values
                    ? Object.entries(variant.option_values)
                        .map(([key, value]) => `${key}: ${value}`)
                        .join(' · ')
                    : '—'}
                </td>
                <td>{formatPrice(variant.price, part.currency)}</td>
                <td>{variant.available ? 'Yes' : 'No'}</td>
                <td>{variant.variant_id === currentVariantId ? 'Yes' : ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
